export default __webpack_public_path__ + "static/media/97.31be84d6.jpg";